import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Close } from '@mui/icons-material';
import RichText from 'Components/RichText/RichText';
import type { NewsVM } from '../../../hooks/useDashboardPage';
import { HeaderImage, Body, Tag, Title, DateLabel, CloseButton } from './NewsDetailModal.styled';

export interface NewsDetailModalProps {
  /** Noticia a mostrar; null → el modal está cerrado. */
  news: NewsVM | null;
  onClose: () => void;
  closeLabel: string;
}

/**
 * Detalle de una noticia del rail: imagen (si hay), tag/fecha, título y la
 * descripción completa renderizada como HTML sanitizado. Cierra por X,
 * backdrop y Esc.
 */
export default function NewsDetailModal({ news, onClose, closeLabel }: NewsDetailModalProps) {
  return (
    <Dialog fullWidth maxWidth="sm" open={news !== null} onClose={onClose}>
      {news && (
        <>
          <CloseButton type="button" onClick={onClose} aria-label={closeLabel}>
            <Close fontSize="small" />
          </CloseButton>
          {news.imageUrl && <HeaderImage src={news.imageUrl} alt="" />}
          <Body>
            <Tag>{news.tag}</Tag>
            <Title>{news.title}</Title>
            <DateLabel>{news.dateLabel}</DateLabel>
            <RichText html={news.description} />
          </Body>
        </>
      )}
    </Dialog>
  );
}
